<template>
  <div> 
    
    <div>
    <h1>Device activation</h1> 
    </div>
  <sui-form>
    <sui-form-field>
      <label>Device ID</label>
      <input placeholder="abcdefg" v-model="deviceId" >
    </sui-form-field>
    <sui-form-field>
      <label>PIN</label>
      <input placeholder="123456789" v-model="pin" >
    </sui-form-field>
    <sui-message v-if="error" color="red">
      <sui-message-header>Activation error</sui-message-header>
      <p>
        {{ error }}
      </p>
    </sui-message>
    
    <sui-button content="Cancel" icon="backward" @click="$router.push({'name': 'device_list'})" />
    <sui-button content="Activate" icon="check" v-on:click="activateDevice($event)" :loading="loading ? true : false" :disabled="loading ? true : false" positive />
    
  </sui-form>
  </div>
</template>

<script>
import DziService from '@/DziService'

export default {
  name: 'DeviceActivation',
  data () {
        return {
            deviceId: null,
            pin: null,
            error: null,
            loading: false
        }
    },  
  methods: {
        async getDevice () {
            const response = await DziService.getDevice(this.$route.params.id)
            this.device = response.data;
        },
        async activateDevice (event) {
            event.preventDefault();
            this.loading = true;
            this.error = null;
            const response = await DziService.activateDevice(this.deviceId, this.pin)
            
            if (typeof response.error !== 'undefined')
            {
                this.error = response.error;
                this.loading = false;
            }
            else if (response.status == 'ok')
            {
                this.$store.commit('resetDevices');
                this.$router.push({'name': 'device_list'})
                // callback?
            }
                
        },
    }
    
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
